var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear/ Bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 17.9998V10.9998M8 17.9998V10.9998M12 17.9998V10.9998M16 17.9998V10.9998M20 17.9998V10.9998M1 21.9998H23M12.37 2.14984L21.37 5.74984C21.72 5.88984 22 6.30984 22 6.67984V9.99984C22 10.5498 21.55 10.9998 21 10.9998H3C2.45 10.9998 2 10.5498 2 9.99984V6.67984C2 6.30984 2.28 5.88984 2.63 5.74984L11.63 2.14984C11.83 2.06984 12.17 2.06984 12.37 2.14984ZM22 21.9998H2V18.9998C2 18.4498 2.45 17.9998 3 17.9998H21C21.55 17.9998 22 18.4498 22 18.9998V21.9998Z",
    stroke: "#758295",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 8.5C12.197 8.5 12.392 8.4612 12.574 8.38582C12.756 8.31044 12.9214 8.19995 13.0607 8.06066C13.1999 7.92137 13.3104 7.75601 13.3858 7.57403C13.4612 7.39204 13.5 7.19698 13.5 7C13.5 6.80302 13.4612 6.60796 13.3858 6.42597C13.3104 6.24399 13.1999 6.07863 13.0607 5.93934C12.9214 5.80005 12.756 5.68956 12.574 5.61418C12.392 5.5388 12.197 5.5 12 5.5C11.6022 5.5 11.2206 5.65804 10.9393 5.93934C10.658 6.22064 10.5 6.60218 10.5 7C10.5 7.39782 10.658 7.77936 10.9393 8.06066C11.2206 8.34196 11.6022 8.5 12 8.5Z",
    stroke: "#758295",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.5198f44aa09dcf12fd0b772ccc035575.svg";
export { ForwardRef as ReactComponent };